import { GenderMaleFemaleVariantIcon } from './GenderMaleFemaleVariantIcon';

/**
 * author: Simran
 * id 1599350F-AA11-47A2-8D1C-B60DF1A0A5AD
 * name gender-male-female-variant
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gender-male-female-variant.svg
 * tags
 */
export const MercuryIcon = GenderMaleFemaleVariantIcon;
export default MercuryIcon